var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option-item",on:{"click":function($event){return _vm.$emit('option-click')}}},[_c('div',{staticClass:"option-item-icon"},[_vm._t("option-item-icon")],2),_vm._v(" "),_c('div',{staticClass:"option-item-text"},[_vm._t("option-item-text")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81ba76e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/optimus/OptiSelectItem.vue
// module id = null
// module chunks = 